import React, { Component } from "react"
import { ProposalReadContainer, ProposalEditContainer } from "components/proposals/redux/ProposalContainers"
import ProposalCardMineBasic from "components/proposals/layout/ProposalCardMineBasic"
import ProposalCardAnyBasic from "components/proposals/layout/ProposalCardAnyBasic"

export class ProposalMinePage extends Component { render() { return (<ProposalCardMineBasic />) } }
export class ProposalAnyPage extends Component { render() { return (<ProposalCardAnyBasic />) } }

export class ProposalReadPage extends Component { render() { return (<ProposalReadContainer proposalId={this.props.match.params.proposalId} />) } }
export class ProposalEditPage extends Component { render() { return (<ProposalEditContainer proposalId={this.props.match.params.proposalId} />) } }